export const TEST_OPTIONS = [
	{
		value: 'variant_site',
		label: 'Site variant',
	},
];
